Ext.define('SA.model.LocationValue.Normalized', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            var object = SA.Object.of(value);

            return object
                && object.hasType(['locationSeries', 'combination', 'radius'])
                && object.keysAre(['type', 'id', 'isNormalized', 'locationSeries', 'radius', 'geographicUnit'])
                && object.property('isNormalized') === true
                && object.testProperty('locationSeries', value => Array.isArray(value))
                && object.testProperty('radius', value => Number.isFinite(value));
        }
    },

    getId() {
        if (SA.model.CustomLocationStringId.match(this.value.id)) {
            return SA.model.CustomLocationStringId.getInteger(this.value.id);
        }

        return this.value.id;
    },

    toNormalized() {
        return this.value;
    }
});